module.exports = {
  src: __webpack_public_path__ + "assets/images/icons8-schedule.12506817e453a23c.svg",
  width: 24,
  height: 24,
  toString: function() { return __webpack_public_path__ + "assets/images/icons8-schedule.12506817e453a23c.svg"; }
};